import http from './http';

export const getMyNasabah = () => http.get('/me/nasabah').then((r) => r.data);
export const changeMyPassword = (payload) => http.put('/me/password', payload).then((r) => r.data);
export const updateMyNasabah = (payload) => http.put('/me/nasabah', payload).then((r) => r.data);
export const listMyPengajuanPenarikan = () => http.get('/me/pengajuan-penarikan').then((r) => r.data);
export const createPengajuanPenarikan = (payload) => http.post('/me/pengajuan-penarikan', payload).then((r) => r.data);
